module.exports = {"Description":"SO : AA NNNNN","RedundantCharacters":" -","ValidationRegex":"^[a-zA-Z]{2}[0-9]{5}$","TestData":{"Valid":["AW12345","BN47899"],"Invalid":["12345","A12345","SL123456"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/SO.json
// module id = 4487
// module chunks = 11